import {Endpoints} from '../../../../globals/api/endpoints';

export class CopyrightsEndpoints extends Endpoints {

  private static readonly COPY = CopyrightsEndpoints.VIEWER + '/copyrights';
  public static readonly COPYRIGHTS = CopyrightsEndpoints.COPY + '/' + CopyrightsEndpoints.PROJECT_ID;
  public static readonly COPYRIGHTS_PREVIEW = CopyrightsEndpoints.COPY + '/' + CopyrightsEndpoints.VERSION_ID + '/preview';
}
